import { CardOrientation } from '@/types/slide';
import { Box, BoxProps, Chip, styled } from '@mui/material';

export const CardContainer = styled(Box)(() => ({
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    alignContent: 'center',
    justifyItems: 'center',
    justifyContent: 'center',
    position: 'relative',
}));

export interface CardDisplayProps {
    direction?: 'row' | 'column';
    imgUrl?: string;
    order?: number;
    orientation?: CardOrientation;
}

export const CardDisplay = ({ orientation, direction, imgUrl, order, sx, ...props }: CardDisplayProps & BoxProps) => {
    const imageUrl = imgUrl;
    const rotateOrientation = (orientation: string | undefined) => {
        switch (orientation) {
            case 'Left':
                return 'rotate(-90deg)';
            case 'Right':
                return 'rotate(90deg)';
            case 'Up':
                return 'none';
            case 'Down':
                return 'rotate(180deg)';
            default:
                return 'none';
        }
    };

    return (
        <Box
            sx={[
                {
                    width: direction === 'row' ? '100%' : 'auto',
                    height: direction === 'row' ? 'auto' : '100%',
                    minWidth: direction === 'row' ? 100 : 150,
                    minHeight: direction === 'row' ? 150 : 100,
                    aspectRatio: direction === 'row' ? 2 / 3 : 3 / 2,
                    objectFit: 'contain',
                    boxShadow: 1,
                    borderRadius: 1,
                    display: 'flex',
                    alignItems: 'center',
                    alignContent: 'center',
                    justifyItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'white',
                    backgroundSize: 'cover',
                    position: 'relative',
                },
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
            {...props}
        >
            {imageUrl && (
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        overflow: 'hidden',
                    }}
                >
                    <img
                        src={imageUrl}
                        style={{
                            width: '100%',
                            height: direction === 'column' ? '150%' : '100%',
                            objectFit: 'contain',
                            transform: rotateOrientation(orientation),
                            transformOrigin: 'center',
                        }}
                    />
                </div>
            )}
            {props.children}
            {order && <Chip sx={(theme) => ({ position: 'absolute', top: theme.spacing(0.5), right: theme.spacing(0.5) })} label={order} />}
        </Box>
    );
};
